import React, { Component } from 'react';
import CurrencyValue from './currencyValue';
import ChangeValue from './changeValue';

class DovizKur extends Component {
    state = {  
        values: [],
        header: this.props.header,
        showdescription: this.props.showdescription,
        style:{height: document.body.clientWidth > 990 ? this.props.height : null}
    }

    componentDidUpdate(prevProps) {
  
      if (this.props.values !== prevProps.values && Array.isArray(this.props.values)) 
      {
        var values = this.props.values;

        if(this.props.main)
           values = this.props.values.filter( (value) => value.Main === true)

        if(this.props.group !== undefined)
           values = values.filter( (value) => value.DataGroup === this.props.group)

        if(this.props.webgroup !== undefined)
           values = values.filter( (value) => value.WebGroup === this.props.webgroup)

        // Hem alış hem satış değeri 0 olan kuru gösterme
        // (değerler "0,000" gibi virgüllü metin gelebiliyor)
        var toNumber = (v) => parseFloat(String(v).replace(/\./g, '').replace(',', '.'))
        values = values.filter( (value) => !(toNumber(value.Alis) === 0 && toNumber(value.Satis) === 0))

        this.setState({values})
      }
    }


    showCode = tag =>{
      var windowWidth = document.body.clientWidth;
      if (this.props.showdescription && (windowWidth < 630 || (windowWidth <1340 && windowWidth > 992)) === false){
        var aciklama = ''
        if(tag['Aciklama'])
          aciklama = '(' + tag['Aciklama'] + ')'
        return <td>{tag['Kod']} <span>{aciklama}</span></td>;
      }
      else
        return <td>{tag['Kod']}</td>;
    }


    render() { 
        return <div className={this.props.goldHead ? "card gold-head" : "card blue-head"}>
          <div className="card-body">
            <div className="card-box" style={this.state.style}>
                <div className="table-responsive">
                  <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">{this.state.header}</th>
                          <th scope="col">{this.props.hideValueLabels ? '' : 'Alış'}</th>
                          <th scope="col">{this.props.hideValueLabels ? '' : 'Satış'}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                          {this.state.values.map(tag => <tr key={tag['Kod']}>{this.showCode(tag)}<CurrencyValue id={'buy' + tag['Kod']} value={tag['Alis']}/><CurrencyValue id={'sell' + tag['Kod']} value={tag['Satis']}/><ChangeValue value={tag['Change']} /></tr>)}
                      </tbody>
                    </table>
                </div>
            </div>
          </div>
        </div>;
    }

    
}
 
export default DovizKur;